// PostHog initializes in components/PostHogInit.tsx after hydration.
// See lib/posthog-init.ts — early init here injected scripts into <body> and
// caused React hydration mismatches with SSR markup.

export {};
